import { NavigationControl, Popup } from 'react-map-gl';
import styled from 'styled-components';
import { MEDIA_QUERY } from '@pass-frontend/utility/style-helpers';

export const StyledSectionWrapper = styled.div`
  padding: 32px 0;

  .filter-wrapper {
    flex-direction: column;
  }

  ${MEDIA_QUERY.desktop} {
    padding: 96px 0;

    .filter-wrapper {
      flex-direction: row;
    }
  }
`;

export const StyledGymsSearchTitle = styled.div`
  margin-bottom: 32px;

  ${MEDIA_QUERY.desktop} {
    margin-bottom: 64px;
  }
`;

export const StyledDivForDropDown = styled.div`
  background: #ffffff;
  box-sizing: border-box;
  height: 40px;

  .rds-tertiary-button {
    height: 40px;
    padding: 0 16px;
    font-size: 14.22px;
    width: 100%;
    border-radius: 20px !important;
    font-weight: 400;

    ${MEDIA_QUERY.desktop} {
      width: 192px;
    }
  }

  .select-dropdown__control.control {
    border-color: #b1b2b4;
  }

  .select-dropdown__placeholder {
    color: #000000;
    font-size: 14.22px;
  }

  .select-dropdown__menu {
    padding: 24px !important;
  }

  .rds-radio {
    font-size: 14.22px;
    line-height: 20px;
    align-items: center;
    color: #4d4d4d;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
  }

  .rds-radio:hover .rds-radio-icon {
    border-color: #333333;
  }

  .rds-radio .rds-radio-icon {
    border: 2px solid #b3b3b3;
    border-radius: 50%;
    box-sizing: border-box;
    color: #002677;
    height: 24px;
    margin-right: 8px;
    position: relative;
    width: 24px;
  }

  .rds-radio input[type='radio'] {
    border: 0 !important;
    clip: rect(0, 0, 0, 0) !important;
    height: 0.01em !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    white-space: nowrap !important;
    width: 0.01em !important;
    opacity: 0;
  }

  .rds-radio input[type='radio']:checked + .rds-radio-icon {
    border-color: currentColor;
  }

  .rds-radio input[type='radio']:checked + .rds-radio-icon::after {
    background: currentColor;
    border-radius: 50%;
    content: '';
    height: 16px;
    left: 50%;
    margin: -8px 0 0 -8px;
    position: absolute;
    top: 50%;
    width: 16px;
  }

  .has-text-nowrap {
    white-space: nowrap !important;
  }

  .rds-primary-button {
    background-color: #002677;
    color: #ffffff;
    border: none;
    border-radius: 28px;
    line-height: 20px;
    padding: 10px 24px;
    font-size: 14.22px;
    font-family: 'Optum Sans Bold', Helvetica, Arial, sans-serif;
    font-weight: 700;
    cursor: pointer;
  }

  .select-dropdown__menu {
    width: 100%;
  }

  ${MEDIA_QUERY.desktop} {
    width: 192px;
  }
`;

export const StyleAddressZipInput = styled.div`
  &.error .typeahead__control {
    border-color: #a32a2e;
  }

  .typeahead__control {
    height: 40px;
    font-size: 14px;
    box-sizing: border-box;
    border: 1px solid #b3b3b3;
    border-radius: 20px;

    .typeahead__value-container {
      padding: 0 16px;
      cursor: text;
    }
    .typeahead__single-value {
      font-size: 14.22px;
      color: #000000;
      max-width: calc(100% - 32px);
    }

    .typeahead__placeholder {
      display: none;
    }

    ${MEDIA_QUERY.desktop} {
      width: 35vw;
      max-width: 472px;
    }
  }

  ${MEDIA_QUERY.desktop} {
    .locationbox {
      display: inline-block;
    }
  }
`;

export const StyledGymSearchInput = styled.div`
  cursor: text;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b3b3b3;
  border-radius: 20px;
  height: 40px;

  > input {
    outline: none;
    border: none;
    background: transparent;
    width: 100%;
    height: 100%;
    padding: 0 16px;
  }

  ${MEDIA_QUERY.desktop} {
    width: 18.33vw;
    max-width: 264px;
  }
`;

export const StyledListMapWrapper = styled.div`
  margin-top: 24px;
`;

export const StyledGymsCount = styled.div`
  margin-bottom: 8px;
  width: 100%;
`;

export const StyledNoSuggestionErrorMessage = styled.p`
  margin-top: 8px;
`;

export const StyledMapDiv = styled.div`
  contain: content;
  box-sizing: border-box;
  border-style: solid;
  border-color: #b3b3b3;
  border-radius: 8px;
  border-width: 1px;
  height: 540px;

  &.gym-selected {
    border-radius: 8px 8px 0 0;
    border-width: 1px 1px 0 1px;
  }

  ${MEDIA_QUERY.desktop} {
    height: 736px;

    &,
    &.gym-selected {
      border-width: 1px 1px 1px 0px;
      border-radius: 0px 8px 8px 0px;
    }
  }
`;

export const StyledNavigationControl = styled(NavigationControl)`
  top: 24px;
  right: 24px;
`;

export const StyledLabels = styled.div`
  margin-bottom: 8px;
`;

export const StyledDivWrapper = styled.div`
  margin-bottom: 8px;

  ${MEDIA_QUERY.desktop} {
    margin-bottom: 0;
    padding-right: 32px;
  }
`;

export const StyledButtonTheme = styled.button`
  &.btn {
    width: 100%;
    padding: 6px 16px;
    margin-top: 10px;

    ${MEDIA_QUERY.desktop} {
      padding: 8px 16px;
      font-size: 12px;
      margin-top: 23px;
      width: 121px;
    }
  }
`;

export const StyledWelcomeTitle = styled.p`
  margin-bottom: 8px;

  ${MEDIA_QUERY.desktop} {
    margin-bottom: 16px;
  }
`;

export const StyledMarkUpButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  width: 25px;
  height: 34px;
  color: #007897 !important;
  padding: 0;

  &:hover {
    filter: drop-shadow(0px 6px 10px rgba(0, 0, 0, 5));
  }
  &.has-focus {
    color: #054b5c !important;
  }
`;

export const Marker = styled.div`
  .focus-marker {
    z-index: 1;
  }
`;

export const StyledMapParentDiv = styled.div`
  position: relative;
  flex: 1;
`;

export const StyledMapPopUp = styled(Popup)`
  .mapboxgl-popup-content {
    padding: 12px 12px 8px;
  }
`;

export const StyledGymDetailsView = styled.div`
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  padding: 16px;
  border-style: solid;
  border-color: #b3b3b3;
  border-width: 0 1px 1px 1px;

  ${MEDIA_QUERY.desktop} {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    padding: 16px;
    bottom: 56px;
    width: 304px;
    border-radius: 8px;
    border-width: 0;
  }
`;

export const StyledImage = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;

  ${MEDIA_QUERY.desktop} {
    width: 80px;
    height: 80px;
  }
`;

export const StyledGymsDetailsWrapper = styled.div`
  width: 160px;
  margin-left: 16px;

  ${MEDIA_QUERY.desktop} {
    margin-left: 32px;
  }
`;

export const StyledDetailsText = styled.div`
  white-space: nowrap;
  overflow: hidden;
`;

export const StyledSelectedGymDistance = styled.p`
  span {
    margin-left: 8px;
  }
`;

export const StyledTabs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-top: 16px;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 2px solid #e0e0e0;
    padding: 8px 32px;
    width: 50%;
  }

  div:hover {
    cursor: pointer;
  }
  .focused {
    border-bottom: 2px solid #ff612b;
  }

  .notFocused {
    color: #002677;
  }
`;

export const StyledTierName = styled.p`
  display: inline-block;
  border-radius: 27px;
  margin-top: 8px;
  padding: 4px 8px;

  &.Premium {
    background: #bfe9fe;
  }

  &.Classic {
    background: #f8ceae;
  }

  &.Elite {
    background: #fbd89a;
  }

  &.Standard {
    background: #c4efe9;
  }
`;

export const StyledAvailableGymsWrapper = styled.div`
  margin-top: 8px;
`;

export const StyledJoinNowButton = styled.div`
  margin-top: 24px;

  .btn {
    width: 100%;
  }

  ${MEDIA_QUERY.desktop} {
    margin-top: 40px;

    .btn {
      width: auto;
    }
  }
`;
